module.exports = __webpack_public_path__ + "static/julia-is-going-for-a-walk_2007-930633baf669e7c096adcb20a8623f15.jpg";